declare namespace $ {

	type $mol_view__event_bog_ui_command_1 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_ui_command['backdrop_click'] > ): ReturnType< $bog_ui_command['backdrop_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_string__hint_bog_ui_command_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_ui_command_3 = $mol_type_enforce<
		ReturnType< $bog_ui_command['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_list__rows_bog_ui_command_4 = $mol_type_enforce<
		ReturnType< $bog_ui_command['result_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__event_bog_ui_command_5 = $mol_type_enforce<
		({ 
			keydown( next?: ReturnType< $bog_ui_command['key_down'] > ): ReturnType< $bog_ui_command['key_down'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_ui_command_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_command extends $mol_view {
		backdrop_click( next?: any ): any
		Backdrop( ): $mol_view
		key_down( next?: any ): any
		Search( ): $mol_string
		result_rows( ): readonly(any)[]
		Results( ): $mol_list
		Dialog( ): $mol_view
		showed( next?: boolean ): boolean
		query( next?: string ): string
		commands( ): readonly(any)[]
		filtered( ): readonly(any)[]
		selected( next?: number ): number
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_command_showed': ReturnType< $bog_ui_command['showed'] >,
		}) 
	}
	
	type $mol_view__sub_bog_ui_command_group_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_command_group extends $mol_view {
		Title( ): $mol_view
		title( ): string
		sub( ): readonly(any)[]
	}
	
	type $mol_view__sub_bog_ui_command_item_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_command_item_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_command_item extends $mol_button_minor {
		execute( next?: any ): any
		Label( ): $mol_view
		Shortcut( ): $mol_view
		label( ): string
		shortcut( ): string
		active( ): boolean
		click( next?: ReturnType< $bog_ui_command_item['execute'] > ): ReturnType< $bog_ui_command_item['execute'] >
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_command_item_active': ReturnType< $bog_ui_command_item['active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
}

//# sourceMappingURL=command.view.tree.d.ts.map